<app-info-form-box>
  <div class="failed-translation-note">
    <p class="failed-translation-note__text mb-0" [attr.id]="textId()">
      @switch (failure().reason) {
        @case ('tooLong') {
          @if (isShortening()) {
            {{
              'SHARED.TRANSLATE_DIALOG.FAILED.TOO_LONG_IN_FIELD'
                | translate: { length: value().length, maxLength: failure().maxLength }
            }}
          } @else {
            {{
              'SHARED.TRANSLATE_DIALOG.FAILED.TOO_LONG'
                | translate: { length: failure().length, maxLength: failure().maxLength }
            }}
          }
        }
        @case ('missing') {
          {{ 'SHARED.TRANSLATE_DIALOG.FAILED.MISSING' | translate }}
        }
        @case ('unsupportedLanguage') {
          {{ 'SHARED.TRANSLATE_DIALOG.FAILED.UNSUPPORTED_LANGUAGE' | translate }}
        }
        @default {
          {{ 'SHARED.TRANSLATE_DIALOG.FAILED.UNKNOWN' | translate }}
        }
      }
    </p>
    @if (rejectedText(); as text) {
      <button
        matButton
        type="button"
        class="failed-translation-note__use"
        [disabled]="disabled()"
        [attr.aria-label]="
          fieldName()
            ? ('SHARED.TRANSLATE_DIALOG.FAILED.USE_SUGGESTION_FOR'
              | translate: { field: fieldName() })
            : null
        "
        [attr.data-testid]="testId() ? 'btn-use-rejected-text-' + testId() : null"
        (click)="useRejectedText.emit(text)">
        {{ 'SHARED.TRANSLATE_DIALOG.FAILED.USE_SUGGESTION' | translate }}
      </button>
    }
  </div>
</app-info-form-box>
